module.exports = __webpack_public_path__ + "img/gh-43160-1.prt.ebb1f658.jpg";